import React, { useEffect, useMemo, useRef, useState } from 'react'
import { connect, useSelector, useDispatch } from 'react-redux'
import { useHistory } from 'react-router-dom'
import { compose } from 'redux'
import moment from 'moment'
import { Link } from 'react-router-dom'
import ModalConfirm from '../../components/ModalConfirm/index.js'
import { deleteSimuPlayerSaga, refreshSimuPlayersSaga, getSimuPlayersSaga, createArchivePlayerSaga, getDashboardSaga } from './saga.js'
import injectSaga from '../../utils/injectSaga.js'
import { deleteSimuPlayer, createArchivePlayer, getSimuPlayers } from '../App/actions.js'
import ModalArchive from '../../components/ModalArchive/index.js'
import config from '../../config/configurator.js'
import Avatar4 from '../../images/Avatar4.svg'
import UiEdit from '../../images/edit.svg'
import UiDelRed from '../../images/closeRed.svg'
import UiArchive from '../../images/Archive.svg'
import SearchIcon from '../../images/search.svg'
import ResetIcon from '../../images/delete.svg'
import Arrow from '../../images/Arrowdown.svg'
import {
  Loader, FirstContainer, ContainerFirstStudent, AvatarContainer,
  TextFirstCSV,
} from './styledComponents.js'
import {
  TablePageLayout, FilterRow, FilterSearchBox, FilterIconBtn, PaginationRow,
  TableCard, TableScroll, StyledTable, STHead, STH, STBody, STR, STD,
  PlayerCellWrapper, InitialBubble, PlayerRowLink, PlayerRowSpan,
  PermisTag, StatusTag2, TableActions2, TActionBtn, AgencyCellLink,
  InlineDateFilter, NoneText,
} from '../SimuPlayers/styledComponents.js'
import { LicenceSelector, StatusSelector, SelectorContainer } from './styledComponents.js'

const isB2VM = process.env.REACT_APP_TYPE === 'b2vm'

const getInitials = (fullName) => {
  const parts = fullName.trim().split(/\s+/)
  if (parts.length === 1) return (parts[0]?.[0] || '?').toUpperCase()
  return ((parts[0]?.[0] || '') + (parts[parts.length - 1]?.[0] || '')).toUpperCase()
}

const MiniProgressBar = ({ count, total }) => (
  <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', minWidth: '7rem' }}>
    <div style={{ flex: 1, height: '5px', background: '#EEF0F6', borderRadius: '100px', overflow: 'hidden' }}>
      <div style={{
        height: '100%',
        width: `${total ? Math.min(100, count / total * 100) : 0}%`,
        background: 'linear-gradient(90deg, #00C4F3, #6462FC)',
        borderRadius: '100px',
        transition: 'width 0.3s',
      }} />
    </div>
    <span style={{ fontFamily: 'Poppins', fontSize: '0.72rem', color: '#6B7280', whiteSpace: 'nowrap' }}>
      {count}/{total}
    </span>
  </div>
)

const SimuPlayersWorkshop = () => {
  const dispatch = useDispatch()
  const history = useHistory()

  const simuPlayers    = useSelector(s => s.toJS().global.simuPlayers    || [])
  const pageIndex      = useSelector(s => s.toJS().global.pageIndex      || 0)
  const agencies       = useSelector(s => s.toJS().global.agencies)
  const agencytoken    = useSelector(s => s.toJS().global.agencytoken)
  const agencyid       = useSelector(s => s.toJS().global.agencyid)
  const isAdmin        = useSelector(s => s.toJS().global.isAdmin)
  const loading        = useSelector(s => s.toJS().global.loading)
  const dashboardData  = useSelector(s => s.toJS().global.dashboard      || {})
  const totalSimuPlayers = useSelector(s => s.toJS().global.totalSimuPlayers)
  const pageSize       = useSelector(s => s.toJS().global.pageSize       || 2)

  const [showArchiveModal,  setShowArchiveModal]  = useState(false)
  const [actualDrivingTotal, setActualDrivingTotal] = useState('')
  const [licenceDate,       setLicenceDate]       = useState('')
  const [licenceAttempts,   setLicenceAttempts]   = useState('')
  const [showModal,    setShowModal]    = useState(false)
  const [modalText,    setModalText]    = useState('')
  const [modalName,    setModalName]    = useState('')
  const [playerId,     setPlayerId]     = useState('')
  const [filters,      setFilters]      = useState({ students: '', email: '', agency: 'all', licence: 'all', date: '', status: 'all' })
  const [activatedButton, setActivatedButton] = useState(false)
  const [activatedColor,  setActivatedColor]  = useState(false)
  const isFirstFilterEffect = useRef(true)

  useEffect(() => {
    if (!agencytoken) return
    dispatch(getSimuPlayers(filters, agencies, agencytoken, pageSize, 0))
  // eslint-disable-next-line
  }, [agencytoken, pageSize])

  useEffect(() => {
    if (!agencytoken) return
    if (isFirstFilterEffect.current) {
      isFirstFilterEffect.current = false
      return
    }
    const timer = setTimeout(() => {
      dispatch(getSimuPlayers(filters, agencies, agencytoken, pageSize, 0))
    }, 350)
    return () => clearTimeout(timer)
  // eslint-disable-next-line
  }, [filters.students, filters.email, agencytoken, pageSize])

  const findAgencyName = (agencyId) => {
    if (agencies == null) return ''
    if (agencyId == null) return 'Non affilié'
    const agency = isB2VM
      ? agencies.find(a => a.agencyId === agencyId)
      : agencies.find(a => a.id === agencyId)
    return agency != null ? agency.agencyname || agency.agencyName : 'Aucune agence'
  }

  const convertInTime = (time) => {
    if (time) {
      const h = parseInt(time / 60 / 60)
      const m = parseInt(time / 60 % 60)
      const s = parseInt(time % 60)
      return `${h}h ${m}m${s}s`
    }
    return 'Non démarré'
  }

  const confirmDelete = (id, action, firstname) => {
    setShowModal(true)
    setPlayerId(id)
    setModalText(`${action}`)
    setModalName(`${firstname}`)
  }

  const confirmArchivePlayer = (id, name) => {
    setShowArchiveModal(true)
    setModalName(name)
    setPlayerId(id)
  }

  const deletePlayer = (id) => {
    dispatch(deleteSimuPlayer(agencytoken, id, agencyid))
    dispatch(getSimuPlayers(filters, agencies, agencytoken, pageSize, 0))
  }

  const archivePlayer = (id) => {
    const data = {
      agencyToken: agencytoken,
      studentId: id,
      actualDrivingTotal,
      licenceDate: moment(licenceDate).toISOString(),
      licenceAttempts,
    }
    dispatch(createArchivePlayer(data))
    setTimeout(() => history.push('/simuplayers/archive'), 10)
  }

  const buildRows = () => {
    if (loading) return []
    return simuPlayers
      .filter(player => player.email.includes('@fake.tgd'))
      .map(player => {
        const { prog } = player
        const pCount  = prog?.Completion?.Count      || 0
        const pTotal  = prog?.Completion?.CountTotal || 0
        const pLicence = isB2VM
          ? player.trainingType
          : player.TrainingType === '1' ? 'B'
          : player.TrainingType === '2' ? 'BEA'
          : player.TrainingType === '3' ? 'AAC'
          : ''
        return {
          eleve:    `${player.firstname} ${player.lastname}`,
          email:    player.email,
          agence:   findAgencyName(player.agencyId),
          agencyId: player.agencyId,
          permis:   pLicence,
          conduite: convertInTime(prog?.PlayTime),
          id:       player.id || player._id,
          eval:     player.evalHours || player.evaluationScore || player.evalScore || '',
          date:     moment(player.dateCreation).format('DD/MM/YYYY'),
          pCount,
          pTotal,
          status:   player.status,
        }
      })
  }

  const rows = useMemo(() => buildRows(), [simuPlayers, loading]) // eslint-disable-line react-hooks/exhaustive-deps

  // ── Selectors ─────────────────────────────────────────────────────
  const licenceArray = [
    { value: 'all', label: 'Tous' },
    { value: 'B',       label: 'B' },
    { value: 'BEA',     label: 'BEA' },
    { value: 'AAC',     label: 'AAC' },
    { value: 'BEA AAC', label: 'BEA AAC' },
  ]
  const statusArray = [
    { value: 'all',     label: 'Tous' },
    { value: 'Actif',   label: 'Actif' },
    { value: 'Inactif', label: 'Inactif' },
  ]

  const handleClickFilters = (e, type) => {
    const updated = { ...filters }
    if      (type === 'students') updated.students = e.target.value
    else if (type === 'agency')   updated.agency   = e.value
    else if (type === 'email')    updated.email    = e.target.value
    else if (type === 'date')     updated.date     = e.target.value
    else if (type === 'licence')  updated.licence  = e.value
    else if (type === 'status')   updated.status   = e.value
    setActivatedButton(true)
    setFilters(updated)
    setActivatedColor(false)
  }

  const handleClickFindSimuPlayers = () => {
    dispatch(getSimuPlayers(filters, agencies, agencytoken, pageSize, 0))
    const hasFilters = filters.students || filters.agency !== 'all' || filters.email || filters.licence !== 'all' || filters.date || filters.status !== 'all'
    const isAllSelected = filters.agency === 'all' || filters.status === 'all' || filters.licence === 'all'
    setActivatedColor(hasFilters && isAllSelected)
    setActivatedButton(hasFilters && isAllSelected)
  }

  const resetFilters = () => {
    const empty = { students: '', email: '', agency: 'all', licence: 'all', date: '', status: 'all' }
    setFilters(empty)
    dispatch(getSimuPlayers(empty, agencies, agencytoken, pageSize, 0))
    setActivatedButton(false)
    setActivatedColor(false)
  }

  const totalUnarchivedPlayers = totalSimuPlayers - (dashboardData.totalArchiveStudents || 0)
  const totalPages = Math.max(1, Math.ceil(totalUnarchivedPlayers / pageSize))
  const isFirstPage = pageIndex <= 0
  const isLastPage  = pageIndex + 1 >= totalPages || simuPlayers.length < pageSize

  const goNextPage = () => { if (!isLastPage)  dispatch(getSimuPlayers(filters, agencies, agencytoken, pageSize, pageIndex + 1)) }
  const goPrevPage = () => { if (!isFirstPage) dispatch(getSimuPlayers(filters, agencies, agencytoken, pageSize, pageIndex - 1)) }

  // ── Agency selector ───────────────────────────────────────────────
  const agencyOptions = useMemo(() => {
    if (!agencies) return [{ value: 'all', label: 'Toutes les agences' }]
    const sorted = [...agencies].sort((a, b) => {
      const A = (a.agencyname || a.agencyName || '').toUpperCase()
      const B = (b.agencyname || b.agencyName || '').toUpperCase()
      return A < B ? -1 : A > B ? 1 : 0
    })
    return [{ value: 'all', label: 'Toutes les agences' }, ...sorted.map(a => ({ value: a.agencyId, label: a.agencyname || a.agencyName }))]
  }, [agencies])

  // ── Loading / empty ───────────────────────────────────────────────
  if (!agencytoken || loading === true) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '60vh' }}>
        <Loader />
      </div>
    )
  }

  const FirstStudent = () => (
    <FirstContainer>
      <ContainerFirstStudent>
        <AvatarContainer><img alt='avatar' src={Avatar4} /></AvatarContainer>
        <TextFirstCSV>
          {simuPlayers.length === 0 
            ? 'Aucun élève n\'a été inscrit a un atelier pour le moment'
            : 'Aucun élève ne correspond à la recherche.'
          }
        </TextFirstCSV>
      </ContainerFirstStudent>
    </FirstContainer>
  )

  const hasRows = rows.length > 0

  return (
    <>
      {!hasRows ? <FirstStudent /> : (
        <TablePageLayout>
          {/* ── Filter bar ── */}
          <FilterRow>
            <FilterSearchBox>
              <img src={SearchIcon} alt='' />
              <input
                onChange={e => handleClickFilters(e, 'students')}
                value={filters.students || ''}
                placeholder='Chercher un élève'
              />
            </FilterSearchBox>
            <FilterSearchBox>
              <img src={SearchIcon} alt='' />
              <input
                onChange={e => handleClickFilters(e, 'email')}
                value={filters.email || ''}
                placeholder='Chercher un email'
              />
            </FilterSearchBox>
            {isAdmin && (
              <StatusSelector
                classNamePrefix='react-select'
                isSearchable={false}
                defaultValue={agencyOptions[0]}
                onChange={e => handleClickFilters(e, 'agency')}
                options={agencyOptions}
              />
            )}
            <LicenceSelector
              classNamePrefix='react-select'
              isSearchable={false}
              defaultValue={
                filters.licence === 'B'       ? licenceArray[1] :
                filters.licence === 'BEA'     ? licenceArray[2] :
                filters.licence === 'AAC'     ? licenceArray[3] :
                filters.licence === 'BEA AAC' ? licenceArray[4] :
                licenceArray[0]
              }
              onChange={e => handleClickFilters(e, 'licence')}
              options={licenceArray}
            />
            <StatusSelector
              classNamePrefix='react-select'
              isSearchable={false}
              defaultValue={
                filters.status === 'Actif'   ? statusArray[1] :
                filters.status === 'Inactif' ? statusArray[2] :
                statusArray[0]
              }
              onChange={e => handleClickFilters(e, 'status')}
              options={statusArray}
            />
            <InlineDateFilter
              value={filters.date || ''}
              type='date'
              onChange={e => handleClickFilters(e, 'date')}
            />
            <FilterIconBtn onClick={handleClickFindSimuPlayers} title='Rechercher'>
              <img src={SearchIcon} alt='' />
            </FilterIconBtn>
            {activatedButton && (
              <FilterIconBtn onClick={resetFilters} title='Réinitialiser'>
                <img src={ResetIcon} alt='' />
              </FilterIconBtn>
            )}
          </FilterRow>

          {/* ── Pagination ── */}
          <PaginationRow>
            <button
              onClick={goPrevPage}
              disabled={isFirstPage}
              style={{ background: 'none', border: '1px solid #E5E7EB', borderRadius: '6px', width: '2rem', height: '2rem', cursor: isFirstPage ? 'default' : 'pointer', opacity: isFirstPage ? 0.4 : 1, fontFamily: 'Poppins' }}
            >‹</button>
            <span style={{ fontFamily: 'Poppins', fontSize: '0.8rem', color: '#6B7280', padding: '0 0.75rem' }}>
              {pageIndex + 1} / {totalPages}
            </span>
            <button
              onClick={goNextPage}
              disabled={isLastPage}
              style={{ background: 'none', border: '1px solid #E5E7EB', borderRadius: '6px', width: '2rem', height: '2rem', cursor: isLastPage ? 'default' : 'pointer', opacity: isLastPage ? 0.4 : 1, fontFamily: 'Poppins' }}
            >›</button>
          </PaginationRow>

          {/* ── Table ── */}
          <TableCard>
            <TableScroll>
              <StyledTable>
                <STHead>
                  <tr>
                    <STH style={{ width: '18%' }}>Élève</STH>
                    <STH style={{ width: '16%' }}>Email</STH>
                    {isAdmin && <STH style={{ width: '13%' }}>Agence</STH>}
                    <STH style={{ width: '7%'  }}>Permis</STH>
                    {config.features.eval && <STH style={{ width: '6%' }}>Éval</STH>}
                    {config.features.eval && <STH style={{ width: '8%' }}>Date</STH>}
                    <STH style={{ width: '9%'  }}>Conduite</STH>
                    <STH style={{ width: '13%' }}>Progression</STH>
                    <STH style={{ width: '8%'  }}>Statut</STH>
                    <STH style={{ width: '9%'  }}>Actions</STH>
                  </tr>
                </STHead>
                <STBody>
                  {rows.map(row => {
                    const isActive = row.status !== 0
                    return (
                      <STR key={row.id} $inactive={!isActive ? 1 : 0}>

                        {/* Élève */}
                        <STD>
                          <PlayerCellWrapper>
                            <InitialBubble>{getInitials(row.eleve)}</InitialBubble>
                            {isActive
                              ? <PlayerRowLink to={{ pathname: `/simuplayers/edit/${row.id}`, query: { id: row.id } }}>{row.eleve}</PlayerRowLink>
                              : <PlayerRowSpan>{row.eleve}</PlayerRowSpan>
                            }
                          </PlayerCellWrapper>
                        </STD>

                        {/* Email */}
                        <STD title={row.email}>
                          <span style={{ fontFamily: 'Poppins', fontSize: '0.8rem', color: '#6B7280' }}>{row.email}</span>
                        </STD>

                        {/* Agence */}
                        {isAdmin && (
                          <STD>
                            <AgencyCellLink
                              $inactive={row.agence === 'Aucune agence' ? 1 : 0}
                              to={{ pathname: row.agence === 'Aucune agence' ? '#' : `/agency/edit/${row.agencyId}`, query: { id: row.agencyId } }}
                            >
                              {row.agence}
                            </AgencyCellLink>
                          </STD>
                        )}

                        {/* Permis */}
                        <STD>
                          {row.permis ? <PermisTag>{row.permis}</PermisTag> : <NoneText>—</NoneText>}
                        </STD>

                        {/* Éval */}
                        {config.features.eval && (
                          <STD>
                            {row.eval ? (
                              <Link
                                style={{ textDecoration: 'underline', color: '#374151', fontSize: '0.85rem', fontFamily: 'Poppins' }}
                                to={{ pathname: `/simuplayers/eval/${row.id}`, query: { id: row.id } }}
                              >
                                {row.eval}
                              </Link>
                            ) : (
                              <span style={{ color: '#D1D5DB', fontSize: '0.85rem', fontFamily: 'Poppins' }}>—</span>
                            )}
                          </STD>
                        )}

                        {/* Date */}
                        {config.features.eval && (
                          <STD>
                            <span style={{ fontFamily: 'Poppins', fontSize: '0.8rem', color: '#6B7280' }}>{row.date}</span>
                          </STD>
                        )}

                        {/* Conduite */}
                        <STD>
                          <Link
                            style={{ fontFamily: 'Poppins', fontSize: '0.8rem', color: '#3494FA', textDecoration: 'none', fontWeight: 500 }}
                            to={{ pathname: `/simuplayers/stats/${row.id}`, query: { id: row.id } }}
                          >
                            {row.conduite}
                          </Link>
                        </STD>

                        {/* Progression */}
                        <STD style={{ overflow: 'visible' }}>
                          <MiniProgressBar count={row.pCount} total={row.pTotal} />
                        </STD>

                        {/* Statut */}
                        <STD>
                          <StatusTag2 $active={isActive ? 1 : 0}>
                            {isActive ? '● Actif' : '● Inactif'}
                          </StatusTag2>
                        </STD>

                        {/* Actions */}
                        <STD>
                          <TableActions2>
                            {isActive ? (
                              <TActionBtn
                                as={Link}
                                to={{ pathname: `/simuplayers/edit/${row.id}`, query: { id: row.id } }}
                                title='Modifier'
                              >
                                <img src={UiEdit} alt='' style={{ width: '0.875rem', height: '0.875rem' }} />
                              </TActionBtn>
                            ) : null}
                            {!isAdmin && isActive && (
                              <TActionBtn
                                onClick={() => confirmArchivePlayer(row.id, row.eleve)}
                                title='Archiver'
                              >
                                <img src={UiArchive} alt='' style={{ width: '0.875rem', height: '0.875rem' }} />
                              </TActionBtn>
                            )}
                            <TActionBtn
                              $danger={1}
                              onClick={() => confirmDelete(row.id, 'Attention, vous allez supprimer définitivement le compte de ', row.eleve)}
                              title='Supprimer'
                            >
                              <img src={UiDelRed} alt='' style={{ width: '0.875rem', height: '0.875rem' }} />
                            </TActionBtn>
                          </TableActions2>
                        </STD>

                      </STR>
                    )
                  })}
                </STBody>
              </StyledTable>
            </TableScroll>
          </TableCard>
        </TablePageLayout>
      )}

      <ModalConfirm
        show={showModal}
        text={modalText}
        name={modalName}
        confirm={() => { deletePlayer(playerId); setShowModal(false) }}
        cancel={() => setShowModal(false)}
        confirmText='Supprimer'
      />
      <ModalArchive
        show={showArchiveModal}
        name={modalName}
        actualDrivingTotal={setActualDrivingTotal}
        licenceDate={setLicenceDate}
        licenceAttempts={setLicenceAttempts}
        cancel={() => setShowArchiveModal(false)}
        confirm={() => { archivePlayer(playerId); setShowArchiveModal(false) }}
        enableButton={(actualDrivingTotal.length > 0 && licenceDate.length > 0 && licenceAttempts.length > 0) || false}
      />
    </>
  )
}

const withConnect    = connect(null, null)
const withRefresh    = injectSaga({ key: 'refreshSimuPlayers',   saga: refreshSimuPlayersSaga })
const withLoader     = injectSaga({ key: 'simuPlayersWorkshopLoader', saga: getSimuPlayersSaga })
const withCreate     = injectSaga({ key: 'createArchivePlayer',   saga: createArchivePlayerSaga })
const withDelete     = injectSaga({ key: 'deleteSimuPlayers',     saga: deleteSimuPlayerSaga })
const withDashboard  = injectSaga({ key: 'getDashboard',          saga: getDashboardSaga })

export default compose(withRefresh, withLoader, withCreate, withConnect, withDelete, withDashboard)(SimuPlayersWorkshop)
